<template>
  <div>
    <Navigation ref="nav_ref" @callbackComponent="callbackComponent"/>
    <!-- 导航栏 -->
    <h1 class="text-hide ny_banner" v-for="(item,index) in banner" :key="index"
        :style="{background:'url('+item.url+') no-repeat center  50%/cover'}">招聘</h1>
    <div class="container ny_content">
      <div class="ny_nav">
        <div class="ny_nav_h">
          <div>
            <h2>招才纳贤</h2>
            <p>RECRUITING TALENTS</p>
          </div>
        </div>
        <div class="ny_nav_dqwz">
          当前位置：<span class="hidden-xs">招才纳贤></span>我的团队
        </div>
      </div>
      <div class="ny_view">

        <div class="row" id="zp">
          <div class="col-md-4 col-sm-6" v-for="(item,index) in recruitList" :key="index">
            <div class="zp_cell">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <h3 class="panel-title">{{ item.name }}</h3>
                </div>
                <div class="panel-body">
                  <div class="zp_info" v-if="item.wages">
                    <b>工资待遇：</b>
                    <pre>{{ item.wages }}</pre>

                  </div>
                  <div class="zp_info" v-if="item.duty">
                    <b>岗位职责：</b>
                    <pre>{{ item.duty }}</pre>

                  </div>
                  <div class="zp_info" v-if="item.requirement">
                    <b>任职要求：</b>
                    <pre>{{ item.requirement }}</pre>

                  </div>
                  <div class="zp_info" v-if="item.address">
                    <b>工作地址：</b>
                    <pre>{{ item.address }}</pre>

                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h3 class="panel-title">工作时间</h3>
              </div>
              <div class="panel-body">
                8:30-17:30，午休2h，双休
              </div>
            </div>

          </div>
          <div class="col-md-12">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h3 class="panel-title">福利待遇</h3>
              </div>
              <div class="panel-body">
                <ul id="zp_gsfl">
                  <li>缴纳五险</li>
                  <li>定期健康体检</li>
                  <li>享受节假日带薪休假</li>
                  <li>节日福利多多</li>
                  <li>生日福利多多</li>
                  <li>定期团建活动</li>
                  <li>公司旅游</li>
                  <li>带薪年假</li>
                  <li>更多福利等你来咨询</li>
                </ul>
              </div>

            </div>
          </div>
          <div class="col-md-12">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h3 class="panel-title">工作地址及联系方式</h3>
              </div>
              <div class="panel-body">
                <p>安徽省合肥市蜀山区信旺华府骏苑5幢704室</p>
                <p>周女士 182 9730 7002</p>
              </div>
            </div>
          </div>
        </div>



      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navigation from '../../components/Navigation'
import Footer from '../../components/Footer'
export default {
  name: 'index',
  components: {
    Navigation,
    Footer
  },
  data () {
    return {
      banner: [],
      recruitList: [],
      queryInfo: {
        limit: 6,
        page: 1,
      },
    }
  },
  created () {
    this.getRecruitList()
  },
  methods: {
    async getRecruitList(){
      const {data: res} = await this.$http.get('home/recruit_list', {params: this.queryInfo})
      if (res.code !== 200) return false
      this.recruitList = res.data.list
    },
    callbackComponent (params) {
      params.function && this[params.function](params.data)
    },
    getBannerList (data) {
      this.banner = data.image
    },
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/recruit/index.vue